import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar'
import Head from './components/Head';
import Header from './components/Header';
import About from './Pages/About';
import Appointment from './Pages/Appointment';
import Gallery from './Pages/Gallery';

function App() {
  return (
    <Router>
      <Head />
      <Header />
      <Navbar />
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Appointment" element={<Appointment />} />
        <Route path="/Gallery" element={<Gallery />} />

      </Routes>


    </Router>
  );
}

export default App;
